import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	isLoading: false,
	AdminRegisterResponse: {},
};

const AdminSlice = createSlice({
	name: "CreateAUser",
	initialState,
	reducers: {
		requestPending: state => {
			state.isloading = true;
		},
		AdminSuccess: (state, { payload }) => {
			state.isLoading = false;
			state.AdminRegisterResponse = payload || {};
		},
		requestFail: (state, { payload }) => {
			state.isLoading = false;
			state.AdminRegisterResponse = payload || {};
		},
	},
});
const { reducer, actions } = AdminSlice;
export const { requestPending, AdminSuccess, requestFail } = actions;
export default reducer;
